import { createSelector } from "@reduxjs/toolkit";
import { MasterSelector } from ".";
import { group } from 'utils/common-util'

export const UltrahighConstSelector = {
  state: (state) => state.constant.ultrahigh,
  fundLoading: (state) => UltrahighConstSelector.state(state).funds.loading,
  fundType: (state) => UltrahighConstSelector.state(state).funds.type,
  fundDetails: (state) => UltrahighConstSelector.state(state).funds.details,
  fetchedFund: (state) => UltrahighConstSelector.state(state).funds.done,
  fundList: createSelector(
    [
      (state) => MasterSelector.isLocaleTH(state),
      (state) => UltrahighConstSelector.state(state).funds.options,
    ],
    (isLocaleTH, fundList) => {
      return fundList.map(fund => {
        const fundName = isLocaleTH ? fund.fundNameTh : fund.fundNameEng
        return {
          ...fund,
          fundName,
          fundNameDisplay: `${fund.fundAbbr} : ${fundName}`,
          filterLabel: [
            `${fund.fundAbbr}:${fundName}`.toLowerCase(),
            `${fund.fundAbbr}:${fundName}`.toLowerCase().replace(/[-]/g, ''),
          ]
        }
      })
    }),
  fundIssuerGroupOptions: createSelector(
    [(state) => UltrahighConstSelector.fundList(state)],
    (fundList) => {
      const opt = {
        listName: 'funds',
        map: funds => funds.map(fund => ({
          label: fund.fundNameDisplay,
          value: fund.fundId,
          filterLabel: fund.filterLabel,
        }))
      }
      return group(fundList, 'issuerName', opt)
    }
  ),
}